import { useState, useEffect, useMemo, useRef } from "react";
import AuthService from "services/auth.service";

/**
 * Fetches all transactions for the current user,
 * sorts newest-first, and exposes them.
 */
export default function useTransactionData() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser?.id;
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    abortRef.current = controller;

    AuthService.getAllTransaction(id)
      .then((response) => {
        if (!controller.signal.aborted) {
          const sorted = response.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setTransactions(sorted);
          setLoading(false);
        }
      })
      .catch((e) => {
        if (!controller.signal.aborted) {
          setError(e);
          setLoading(false);
        }
      });

    return () => controller.abort();
  }, [id]);

  const recentTransactions = useMemo(
    () => transactions.slice(0, 3),
    [transactions]
  );

  return {
    transactions,
    recentTransactions,
    loading,
    error,
  };
}